// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"Loading_container__o1Lrm","text":"Loading_text__rnQTQ"};